import { render } from "./SaveCandidate.vue?vue&type=template&id=0da39c26&scoped=true"
import script from "./SaveCandidate.vue?vue&type=script&lang=js"
export * from "./SaveCandidate.vue?vue&type=script&lang=js"

import "./SaveCandidate.vue?vue&type=style&index=0&id=0da39c26&scoped=true&lang=scss"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da39c26"]])

export default __exports__